import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { NzMessageService } from 'ng-zorro-antd'
import { CustomerService } from '../customer/customer.service'
import { ReportSearch } from '../report/report.model'
import { ReportService } from '../report/report.service'

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss'],
})
export class PanelComponent implements OnInit {
  constructor(private customerService: CustomerService, private route: ActivatedRoute, private service: ReportService, private message: NzMessageService) {}

  list = [
    {
      label: '总消息数',
      value: '更新中',
      rate: 0,
      status: 3,
      key: 'messageNum',
    },
    {
      label: '接入人数',
      value: '更新中',
      rate: 0,
      status: 3,
      key: 'userNum',
    },
    {
      label: '主动发起会话数',
      value: '更新中',
      rate: 0,
      status: 3,
      key: 'activeSessionNum',
    },
    {
      label: '平均首次响应时间',
      value: '更新中',
      rate: 0,
      status: 3,
      key: 'firstReplyTime',
    },
    {
      label: '平均响应时长',
      value: '更新中',
      rate: 0,
      status: 3,
      key: 'replyTime',
    },
    {
      label: '销售额(元)',
      value: '更新中',
      rate: 0,
      status: 3,
      key: 'sales',
    },
    {
      label: '销售量',
      value: '更新中',
      rate: 0,
      status: 3,
      key: 'salesNum',
    },
    {
      label: '客单价(元)',
      value: '更新中',
      rate: 0,
      status: 3,
      key: 'cusUnitPrice',
    },
    {
      label: '询单付款转化率',
      value: '更新中',
      rate: 0,
      status: 3,
      key: 'conversionRate',
    },
    {
      label: '退款额(元)',
      value: '更新中',
      rate: 0,
      status: 3,
      key: 'refundPrice',
    },
    {
      label: '满意度',
      value: '更新中',
      rate: 0,
      status: 3,
      key: 'satisfiedNum',
    },
  ]
  public searchConfig = [
    { type: 'timePiker', name: 'time', nick: '选择时间', placeholder: '请选择时间', startAt: 'createAtStart', endAt: 'createAtEnd', disabled: false },
    {
      type: 'select',
      name: 'customerServiceId',
      nick: '选择客服',
      placeholder: '请选择客服',
      data: [{ value: '全部客服', label: '全部客服' }],
      disabled: false,
    },
  ]
  text:string = '较前一日'
  isSpinning = false
  contrast = null
  params = null
  customerServiceId: string = ''
  time: string = ''
  reportSearch: ReportSearch = null
  options = []
  ngOnInit() {
    this.route.queryParams.subscribe((res) => {
      console.log('接收的参数--->', { ...res })
      this.text = res.createAtStart?'较前一周期':'较前一日'
      const params = Object.assign({}, new ReportSearch(), res, { type: 1 })
      this.params = params
      this.reportSearch = new ReportSearch(params)
      if (!localStorage.getItem('token')) {
        this.login()
      }
      this.getCustomer()
      this.getReport()
    })
  }

  async getReport() {
    try {
      this.isSpinning = true
      if (this.reportSearch.createAtStart == '') {
        this.reportSearch.createAtStart = new Date(new Date().toLocaleDateString()).getTime() - 60 * 60 * 24 * 1000 + ''
        this.reportSearch.createAtEnd = new Date(new Date().toLocaleDateString()).getTime() - 1 + ''
      }
      const { data } = await this.service.getReport(this.reportSearch)
      const { cusAchievementList, customerServiceMap, contrast } = data
      this.contrast = contrast
      if (cusAchievementList.length === 0) {
        this.list.forEach(item=>{
          item.value = '更新中'
          item.rate = 0
          item.status = 3
        })
        this.message.warning('暂无数据')
      } else {
        const cusAchievement = cusAchievementList[0]
        Object.keys(cusAchievement).forEach((key) => {
          this.list.forEach((item) => {
            if (item.key == key) {
              item.value = cusAchievement[key]
              item.rate = contrast[key] * 100
              item.rate.toFixed(2)
              item.status = contrast[key] > 0 ? 1 : contrast[key] == 0 ? 3 : 2
            }
          })
        })
      }
      this.isSpinning = false
      console.log('看板数据--》', data)
      console.log('看板数据--》》', this.list)
      console.log(cusAchievementList)
    } catch (error) {
      console.log(error)
      this.message.error(error.message)
      this.isSpinning = false
    }
  }

  async getCustomer() {
    try {
      const params = {}
      const { data } = await this.service.getCustomer(params)
      this.options = []
      this.options.push({
        value: '',
        label: '全部客服',
      })
      data.forEach((item) => {
        this.options.push({
          value: item.id,
          label: item.name,
        })
      })
      this.searchConfig[1].data = this.options
      console.log('options', this.options)
    } catch (error) {
      this.message.error(error.message)
    }
  }
  async login() {
    try {
      const params = {
        exten: this.params.exten,
        token: this.params.token,
        tokenId: this.params.tokenId,
      }
      const { data } = await this.customerService.login(params)
      localStorage.setItem('merchantId', data.merchants[0].id)
      localStorage.setItem('token', data.token)
    } catch (error) {
      this.message.error(error.message)
    }
  }
}
